import Resource from '@/plugins/sdk/Resource'
import { STRING, UUID, OBJECT, ARRAY } from '@/plugins/sdk/fields'
import Filter from '@/plugins/sdk/Filter'

export default class extends Resource {
  static name = 'filter'
  static label = 'label'

  static get fields () {
    return {
      id: new UUID(),
      label: new STRING(),
      field: new STRING(),
      options: new OBJECT(),
      operators: new ARRAY(),
      instance: new OBJECT(new Filter())
    }
  }

  get filter () {
    if (this.$fields.instance.current.field !== this.$fields.field.current) {
      this.$fields.instance.current.field = this.$fields.field.current
    }

    return this.$fields.instance.current
  }
}
